function CollapseView({ inventory, user, onView }) {
  const DataCard = ({ icon, label, value, accent = "#83c14a" }) => (
    <div
      style={{
        background: "#fff",
        border: "1px solid #E5E7EB",
        borderRadius: "10px",
        padding: "16px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "4px",
          height: "100%",
          background: accent,
        }}
      ></div>
      <div className="d-flex align-items-start gap-3">
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "10px",
            background: `${accent}15`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <i
            className={icon}
            style={{ fontSize: "1.125rem", color: accent }}
          ></i>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              fontSize: "0.75rem",
              color: "#6B7280",
              fontWeight: "600",
              marginBottom: "4px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {label}
          </div>
          <div
            style={{
              fontSize: "1rem",
              color: "#111827",
              fontWeight: "700",
              wordBreak: "break-word",
            }}
          >
            {value || "—"}
          </div>
        </div>
      </div>
    </div>
  );

  // console.log("Inventory: ", inventory);
  // console.log("Users: ", user);

  const isAdmin = user?.roles?.some((r) => r.id === "Admin");

  const variance =
    (inventory?.actualCount || 0) - (inventory?.systemCount || 0);
  const varianceColor =
    variance > 0 ? "#059669" : variance < 0 ? "#DC2626" : "#6B7280";
  const varianceIcon =
    variance > 0
      ? "bi bi-arrow-up-circle-fill"
      : variance < 0
        ? "bi bi-arrow-down-circle-fill"
        : "bi bi-dash-circle-fill";

  return (
    <div
      style={{
        background: "#F9FAFB",
        border: "1px solid #E5E7EB",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "20px",
          paddingBottom: "16px",
          borderBottom: "2px solid #E5E7EB",
        }}
      >
        <i
          className="bi bi-info-circle-fill"
          style={{ fontSize: "1.25rem", color: "#83c14a" }}
        ></i>
        <h6
          style={{
            margin: 0,
            fontSize: "1rem",
            fontWeight: "700",
            color: "#111827",
          }}
        >
          Inventory Details
        </h6>
      </div>

      <div className="row g-3">
        <div className="col-md-12">
          <DataCard
            icon="bi bi-box-seam-fill"
            label="Item Name"
            value={inventory?.itemName}
            accent="#83c14a"
          />
        </div>

        {isAdmin && (
          <div className="col-md-4">
            <DataCard
              icon="bi bi-hdd-stack-fill"
              label="System Count"
              value={inventory?.systemCount}
              accent="#3B82F6"
            />
          </div>
        )}
        {isAdmin && (
          <div className="col-md-4">
            <DataCard
              icon="bi bi-calculator-fill"
              label="Actual Count"
              value={inventory?.actualCount || 0}
              accent="#8B5CF6"
            />
          </div>
        )}
        {/* <div className="col-md-4">
          <div style={{
            background: "#fff",
            border: "1px solid #E5E7EB",
            borderRadius: "10px",
            padding: "16px",
            position: "relative",
            overflow: "hidden"
          }}>
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "4px",
              height: "100%",
              background: varianceColor
            }}></div>
            <div className="d-flex align-items-start gap-3">
              <div style={{
                width: "40px",
                height: "40px",
                borderRadius: "10px",
                background: variance > 0 ? "#D1FAE5" : variance < 0 ? "#FEE2E2" : "#F3F4F6",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}>
                <i className={varianceIcon} style={{ fontSize: "1.125rem", color: varianceColor }}></i>
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: "0.75rem", color: "#6B7280", fontWeight: "600", marginBottom: "4px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                  Variance
                </div>
                <div style={{ fontSize: "1rem", fontWeight: "700", color: varianceColor }}>
                  {variance > 0 ? "+" : ""}{variance}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="col-md-4">
          <DataCard
            icon="bi bi-rulers"
            label="Unit of Measure"
            value={inventory?.uom?.name}
            accent="#F59E0B"
          />
        </div>

        <div className="col-md-4">
          <DataCard
            icon="bi bi-calendar3"
            label="Last Updated"
            value={inventory?.lastAdjusted}
            accent="#06B6D4"
          />
        </div>

        <div className="col-md-4">
          <DataCard
            icon="bi bi-person-circle"
            label="Adjusted By"
            value={inventory?.adjustedBy?.email}
            accent="#EC4899"
          />
        </div>
      </div>
    </div>
  );
}

export default CollapseView;
